module.exports = __webpack_public_path__ + "img/229.weekly_cleaning.bf569076.svg";